<template>
  <div
    id="cup_scheduleDetail_statistics"
    ref="cup_scheduleDetail_statistics"
    v-show="currThemeObj"
  >
    <div class="teamStat_main">
      <div class="teamStat_infor">
        <span class="teamStatInfor_item">
          <span class="teamInforItem_logo" :class="matchInfor.homeLogo ? '' : 'noLogo'">
            <img v-if="matchInfor.homeLogo" :src="matchInfor.homeLogo" />
          </span>
          <span class="teamInforItem_name" v-text="matchInfor.homeName"></span>
        </span>
        <span class="teamStatInfor_item">
          <span class="teamInforItem_logo" :class="matchInfor.awayLogo ? '' : 'noLogo'">
            <img v-if="matchInfor.awayLogo" :src="matchInfor.awayLogo" />
          </span>
          <span class="teamInforItem_name" v-text="matchInfor.awayName"></span>
        </span>
      </div>
      <div class="teamStatMain_item" v-for="row in teamStatArr" :key="row.key">
        <div
          class="itemPer_row"
          v-if="
            row.key == 'possessionPercentage' ||
            row.key == 'passesSuccessfulPercentage'
          "
        >
          <div class="per_contain">
            <cup_svgSingleCircle
              v-if="cy"
              :currThemeObj="currThemeObj"
              teamMode="home"
              :cx="cx"
              :cy="cy"
              :strokeWidth="strokeWidth"
              :svgData="row.svgData[0] ? row.svgData[0] : defaultSvgData"
              :keyArr="cup_svgSingleCircle_keyArr"
              :svgCenterInforArr="['val']"
            ></cup_svgSingleCircle>
          </div>
          <div class="itemPer_title" v-text="`${row.title} (%)`"></div>
          <div class="per_contain">
            <cup_svgSingleCircle
              v-if="cy"
              :currThemeObj="currThemeObj"
              teamMode="away"
              :cx="cx"
              :cy="cy"
              :strokeWidth="strokeWidth"
              :svgData="row.svgData[1] ? row.svgData[1] : defaultSvgData"
              :keyArr="cup_svgSingleCircle_keyArr"
              :svgCenterInforArr="['val']"
            ></cup_svgSingleCircle>
          </div>
        </div>
        <div class="progressBar_row" v-else>
          <span class="progressBarRow_textArea">
            <span class="textArea_val" v-text="row.homeVal"></span>
            <span class="textArea_title" v-text="row.title"></span>
            <span class="textArea_val textAlignR" v-text="row.awayVal"></span>
          </span>
          <span class="progressBarRow_barArea">
            <span
              class="barArea_home"
              :style="{
                width: `calc(${row.homeWidthPer}% - 2px)`,
              }"
            ></span>
            <span
              class="barArea_away"
              :style="{
                width: `calc(${row.awayWidthPer}% - 2px)`,
              }"
            ></span>
          </span>
        </div>
      </div>
    </div>
    <div class="playerStat_main">
      <div
        class="playerStatItem"
        v-for="teamItem in playerTableArr"
        :key="teamItem.teamId"
      >
        <span class="teamInfor">
          <span class="teamInfor_logo">
            <img :src="teamItem.teamLogo" />
          </span>
          <span class="teamInfor_name" v-text="teamItem.teamName"></span>
        </span>
        <div class="tableScrollArea">
          <nodeTree_table
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :currSid="currSid"
            :tableMode="tableMode"
            :parentWidthPx="parentWidthPx"
            :isScrollFlag="isScrollFlag"
            :variableColWidthVw="variableColWidthVw"
            :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
            :defaultWidthVwNum="defaultWidthVwNum"
            :tableColumnData="teamItem.tableColumnData"
            :tableData="teamItem.tableData"
            :tableHeightPx="0"
            :jumpRouterPathNames="jumpRouterPathNames"
            v-show="teamItem.tableData && teamItem.tableData.length > 0"
          ></nodeTree_table>
          <!-- <li v-for="i in count" :key="i" v-text="i"></li> -->
          <p v-if="teamItem.tableData.length == 0">暂无数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  https_cup_scheduleDetailStatTeam,
  https_cup_scheduleDetailStatPlayers,
} from '@api/platfrom_football_api'
import cup_svgSingleCircle from '@components/platfromBase/football/cup_svgSingleCircle.vue'
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'

import cup_base_data_mixin from '@mixins/cup_base_data'
import platfrom_refresh_data_mixin from '@mixins/platfrom_refresh_data'
export default {
  name: 'cup_scheduleDetail_statistics',
  components: { cup_svgSingleCircle, nodeTree_table },
  mixins: [cup_base_data_mixin, platfrom_refresh_data_mixin],
  props: {
    isRefresh: {
      type: Boolean,
      default: false,
    },
    matchInfor: {
      type: Object,
      default: () => ({
        matchStatus: '',
        homeId: '',
        homeName: '',
        homeScore: '',
        homePoint: null,
        homeLogo: '',
        awayId: '',
        awayName: '',
        awayScore: '',
        awayPoint: null,
        awayLogo: '',
        venueId: '',
        venueName: '',
      }),
    },
  },
  data() {
    return {
      defaultSvgData: {
        val: 10,
        name: '11',
        key: 1,
      },
      cup_svgSingleCircle_keyArr: ['name', 'val'],
      strokeWidthVw: 0.83,
      bodyWidth: 0,
      cxVw: 3.125,
      cyVw: 3.125,
      teamStatArr: null,
      showSvgCircelKey: ['possessionPercentage', 'passesSuccessfulPercentage'],
      tableMode: 'playerData',
      jumpRouterPathNames: null,
      parentWidthPx: 0,
      isScrollFlag: true,
      variableColWidthVw: 25.42,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      playerTableArr: null,
    }
  },
  created() {
    if (this.currThemeObj) {
      this.jumpRouterPathNames = {
        pathName_teamDetail: '',
        pathName_playerDetail: `playerDetailIndex_${this.currThemeObj.moduleRouteNameEn}`,
      }
    }
  },
  mounted() {
    console.debug()
    this.onResizeEvent()
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    const query = this.$route.query
    this.init(query)
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  computed: {
    strokeWidth() {
      return Math.ceil((this.bodyWidth / 100) * this.strokeWidthVw)
    },
    cx() {
      return Math.ceil((this.bodyWidth / 100) * this.cxVw)
    },
    cy() {
      return Math.ceil((this.bodyWidth / 100) * this.cyVw)
    },
  },
  methods: {
    onResizeEvent() {
      this.parentWidthPx = this.$refs.cup_scheduleDetail_statistics.clientWidth
      this.bodyWidth = document.body.clientWidth
    },
    async init(query) {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getScheduleDetailStatTeam(query)
      await this.getScheduleDetailStatPlayers(query)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async refreshCallback() {
      const query = this.$route.query
      await this.getScheduleDetailStatTeam(query)
      await this.getScheduleDetailStatPlayers(query)
    },
    async getScheduleDetailStatTeam(query) {
      await https_cup_scheduleDetailStatTeam(
        this.axiosBaseUrl,
        this.$axios,
        query
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const columns = [
              {
                colKey: 'possessionPercentage',
                colTitle: '控球率',
              },
              {
                colKey: 'shots',
                colTitle: '射门',
              },
              {
                colKey: 'shotsOnTarget',
                colTitle: '射正',
              },
              {
                colKey: 'assists',
                colTitle: '助攻',
              },
              {
                colKey: 'corners',
                colTitle: '角球',
              },
              {
                colKey: 'shotsHead',
                colTitle: '头球',
              },
              {
                colKey: 'redCards',
                colTitle: '红牌',
              },
              {
                colKey: 'yellowCards',
                colTitle: '黄牌',
              },
              {
                colKey: 'redCards2ndYellow',
                colTitle: '二黄',
              },
              {
                colKey: 'tackles',
                colTitle: '抢断',
              },
              {
                colKey: 'saves',
                colTitle: '救球',
              },
              {
                colKey: 'passesSuccessfulPercentage',
                colTitle: '传球成功率',
              },
              {
                colKey: 'passes',
                colTitle: '传球',
              },
              {
                colKey: 'crosses',
                colTitle: '传中',
              },
              {
                colKey: 'offsides',
                colTitle: '越位',
              },
            ]
            this.teamStatArr = columns.map((col) => {
              let row = {}
              row.key = col.colKey
              row.title = col.colTitle
              const home = res.data.home
              const away = res.data.away

              if (this.showSvgCircelKey.includes(col.colKey)) {
                let svgData = []
                if (home) {
                  svgData.push({
                    name: '',
                    val: home[col.colKey].toFixed(1) - 0,
                    key: `home_${col.colKey}`,
                  })
                }
                if (away) {
                  svgData.push({
                    name: '',
                    val: away[col.colKey].toFixed(1) - 0,
                    key: `away_${col.colKey}`,
                  })
                }
                row.svgData = svgData
              } else {
                let total = 0
                if (home) {
                  row.homeVal = home[col.colKey]
                  total += row.homeVal
                }
                if (away) {
                  row.awayVal = away[col.colKey]
                  total += row.awayVal
                }
                if (total === 0) {
                  row.homeWidthPer = 50
                  row.awayWidthPer = 50
                } else {
                  row.homeWidthPer = Math.floor((row.homeVal / total) * 100)
                  row.awayWidthPer = 100 - row.homeWidthPer
                }
              }
              return row
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getScheduleDetailStatPlayers(query) {
      await https_cup_scheduleDetailStatPlayers(
        this.axiosBaseUrl,
        this.$axios,
        query
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.playerTableArr = res.data.map((teamItem) => {
              const columns = [
                {
                  colKey: 'shirtNumber',
                  colTitle: '球衣号',
                },
                {
                  colKey: 'playerLogo',
                  colTitle: '球员头像',
                },
                {
                  colKey: 'playerName',
                  colTitle: '球员名称',
                },
                {
                  colKey: 'goals',
                  colTitle: '进球',
                },
                {
                  colKey: 'assists',
                  colTitle: '助攻',
                },
                {
                  colKey: 'shots',
                  colTitle: '射门',
                },
                {
                  colKey: 'shotsOnTarget',
                  colTitle: '射正',
                },
                {
                  colKey: 'shotsOffTarget',
                  colTitle: '射偏',
                },
                {
                  colKey: 'redCards',
                  colTitle: '红牌',
                },
                {
                  colKey: 'yellowCards',
                  colTitle: '黄牌',
                },
                {
                  colKey: 'shotsPenalty',
                  colTitle: '点球',
                },
                {
                  colKey: 'passesSuccessful',
                  colTitle: '传球成功',
                },
                {
                  colKey: 'tacklesWon',
                  colTitle: '抢断成功',
                },
                {
                  colKey: 'interceptions',
                  colTitle: '拦截',
                },
                {
                  colKey: 'fouls',
                  colTitle: '犯规',
                },
                {
                  colKey: 'clearances',
                  colTitle: '解围',
                },
                {
                  colKey: 'blocks',
                  colTitle: '封堵',
                },
                {
                  colKey: 'saves',
                  colTitle: '救球',
                },
              ]
              const fristColumns = columns.slice(0, 3)
              const otherColumns = columns.slice(3)
              this.defaultWidthVwNum = otherColumns.length
              let tableColumnData = []
              let fristColumnPropArr = []
              for (let i = 0; i < fristColumns.length; i++) {
                fristColumnPropArr.push(fristColumns[i].colKey)
              }
              const fristColumn = {
                prop: 'shirtNumber-playerLogo-playerName', //fristColumnPropArr.join('-'),
                label: '球员',
                widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                className: 'columnNumLogoNameClass', //单独定制的头部样式class
                fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
              }

              tableColumnData.push(fristColumn)
              for (let i = 0; i < otherColumns.length; i++) {
                const item = otherColumns[i]
                tableColumnData.push({
                  prop: item.colKey,
                  label: item.colTitle,
                  widthVw: this.tableCellDefaultWidthVw, //对应列的宽度，单位vw
                  className: '', //单独定制的头部样式class
                  selected: item.selected ? item.selected : false,
                })
              }

              return {
                matchId: teamItem.matchId,
                teamId: teamItem.teamId,
                teamLogo: teamItem.teamLogo,
                teamName: teamItem.teamName,
                tableData: teamItem.stats
                  ? teamItem.stats.map((rowItem) => {
                      rowItem.teamId = teamItem.teamId
                      return rowItem
                    })
                  : [],
                tableColumnData,
              }
            })
            if (
              this.isRefresh &&
              this.refreshCallbackHandle &&
              !this.setIntervalId
            ) {
              this.refreshCallbackHandle(this.refreshCallback)
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_scheduleDetail_statistics {
  .teamStat_main {
    padding: 1.042vw 0 1.388vw 0;
    width: 100%;
    height: auto;
    .teamStat_infor {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      height: 6.25vw;
      width: 100%;
      border-bottom: 1px solid rgba(226, 226, 226, 1);
      .teamStatInfor_item {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 40%;
        .teamInforItem_logo {
          width: 2.083vw;
          height: 2.083vw;
          overflow: hidden;
          background-color: rgba(216, 216, 216, 1);
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .teamInforItem_name {
          padding-left: 1.042vw;
          width: calc(100% - 2.083vw);
          font-size: 1.388vw;
          color: rgba(0, 0, 0, 0.85);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &:nth-child(2) {
          justify-content: flex-end;
          flex-direction: row-reverse;
          .teamInforItem_name {
            padding-right: 1.042vw;
            text-align: right;
          }
        }
      }
    }
    .teamStatMain_item {
      padding-top: 0.347vw;
      width: 100%;
      height: auto;
      .itemPer_row {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 8.33vw;
        .per_contain {
          width: 6.25vw;
        }
        .itemPer_title {
          flex: 1;
          text-align: center;
          font-size: 1.388vw;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.85);
        }
      }
      .progressBar_row {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: 5.556vw;
        .progressBarRow_textArea {
          width: 100%;
          height: 1.67vw;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          .textArea_val {
            width: 20%;
            font-size: 1.67vw;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.85);
          }
          .textArea_title {
            width: 60%;
            text-align: center;
            font-size: 1.11vw;
            color: rgba(0, 0, 0, 0.85);
          }
          .textAlignR {
            text-align: right;
          }
        }
        .progressBarRow_barArea {
          padding-top: 1.042vw;
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          .barArea_home {
            transition: width 0.3s linear;
            width: calc(40% - 2px);
            height: 0.694vw;
            border-radius: 0.347vw;
            background-color: var(
              --mixtmt_echarts_shootDis_ExpetGoal_homeColor
            );
          }
          .barArea_away {
            transition: width 0.3s linear;
            width: calc(60% - 2px);
            height: 0.694vw;
            border-radius: 0.347vw;
            background-color: var(
              --mixtmt_echarts_shootDis_ExpetGoal_awayColor
            );
          }
        }
      }
    }
  }

  .playerStat_main {
    padding-top: 1.388vw;
    width: 100%;
    .playerStatItem {
      width: 100%;
      padding-bottom: 2.778vw;
      .teamInfor {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 1.388vw;
        .teamInfor_logo {
          width: 3.472vw;
          height: 3.472vw;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .teamInfor_name {
          padding: 0 0.694vw;
          font-size: 1.388vw;
        }
      }
    }
  }
}

.mixtmt_pc #cup_scheduleDetail_statistics {
}
</style>
